/* eslint-disable */
import legacy$ from 'jquery';
import _ from 'underscore';
import Promise from 'bluebird';
import uiBlocker from '@bingads-webui-component-legacy/uiblocker/service/uiBlocker';
import odata from '@bingads-webui-component-legacy/http/channel/odata';
import appConfig from '@bingads-webui-component-legacy/config/index';
import entityService from '@bingads-webui-static-legacy/entity-service';
import AdGroupCollection from '@bingads-webui-static-legacy/wunderbar/data/collections/adgroupsCollection';
import campaignStatusList from '@bingads-webui-static-legacy/schema/campaign/entityStatus';
import adgroupStatusList from '@bingads-webui-static-legacy/schema/adgroup/entityStatus';
import statusIconLabelList from '@bingads-webui-static-legacy/schema/account/statusIconLabel';
import setting from '@bingads-webui-static-legacy/instrumentation/campaignSchemaAndSetting';
import instruSvc from '@bingads-webui-static-legacy/instrumentation/index';
import '@bingads-webui-static-legacy/instrumentation/instrumentation';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
var Service = function (entityServiceImplementation, viewModel, options, blockerContainer) {
  var serviceInjected = false;
  this.useInjectedAdgroupFetch = false;
  if (entityServiceImplementation) {
    if (_.isFunction(entityServiceImplementation.getCampaigns) && _.isFunction(entityServiceImplementation.getAdgroups)) {
      serviceInjected = true;
      this.useInjectedAdgroupFetch = !!entityServiceImplementation.useInjectedAdgroupFetch;
    } else {
      throw new Error('entityServiceImplementation should contain the methods: getCampaigns and getAdgroups');
    }
  }
  this.entityService = serviceInjected ? entityServiceImplementation : entityService;
  this.options = options;
  this.blockerContainer = blockerContainer;
  this.viewModel = viewModel;
};
var shouldKeepSmartShoppingCampaignAdGroup = function (adgroup, adsCountMap) {
  if (adgroup.Campaign.CampaignSubType !== 'ShoppingSmartAds') {
    return true;
  }
  var permissions = appConfig.get('Permissions');
  var isResponsiveAdForSSCEnabled = permissions.IsResponsiveAdForSSCEnabled;
  var result;
  if (isResponsiveAdForSSCEnabled) {
    result = adgroup.Campaign.CampaignSubType === 'ShoppingSmartAds' && (!adsCountMap[adgroup.Id] || !adsCountMap[adgroup.Id].Product || !adsCountMap[adgroup.Id].Responsive);
  } else {
    result = adgroup.Campaign.CampaignSubType === 'ShoppingSmartAds' && (!adsCountMap[adgroup.Id] || !adsCountMap[adgroup.Id].Product);
  }
  return result;
};
Service.shouldKeepSmartShoppingCampaignAdGroup = shouldKeepSmartShoppingCampaignAdGroup;
Service.prototype = (function () {
  var getCampaignData = function (controlOptions, options, cb) {
    uiBlocker.block(this.blockerContainer, 'getCampaignBlocker', true);
    var campaignId = this.viewModel.selectedCampaign() ? this.viewModel.selectedCampaign().Id : null, campaign = this.viewModel.selectedCampaign() ? this.viewModel.selectedCampaign() : null, predicate = controlOptions.filterPredicate, campaignPredicate = predicate ? predicate.campaign : null;
    this.entityService.getCampaigns({
      success: _.bind(_filterCampaigns, this, options, cb),
      fail: function (error) {
        uiBlocker.unblock(this.blockerContainer, 'getCampaignBlocker');
      },
      filterPredicate: campaignPredicate,
      filterText: options.filterText,
      skip: options.skip,
      take: options.take,
      data: {
        campaignId: campaignId,
        campaign: campaign
      }
    });
    if (_.isFunction(this.viewModel.RefreshAdgroups)) {
      this.viewModel.filterText(options.filterText);
      this.viewModel.RefreshAdgroups();
    }
  };
  var _filterCampaigns = function (options, cb, data) {
    var scope = this.options && this.options.scope;
    if (!data || !data.data) {
      return;
    }
    var campaignData = data.data, query = _.chain(campaignData).filter(_getSearchPredicate(options.filterText)).filter(function (campaign) {
      return campaign.CampaignType !== 16;
    }).filter(function (campaign) {
      var scenario = scope && scope.scenario;
      var level = scope && scope.level;
      var adgroupLevel = 1;
      if ((scenario === 'locations-grid' || scenario === 'ad-schedules-grid') && campaign.CampaignSubType === 12 && level === adgroupLevel) {
        return false;
      }
      if ((scenario === 'negative-keywords-grid' || scenario === 'negative-keyword-lists-grid' || scenario === 'devices-grid') && campaign.CampaignSubType === 12) {
        return false;
      }
      return true;
    }).map(function (cam) {
      return _.extend(cam, {
        name: cam.Name,
        statusHtml: getStatusHtml(campaignStatusList, cam.Status, 'Campaign')
      });
    }), total = data.HasPaged ? data.total : query.value().length, items = data.HasPaged ? query.value() : query.rest(options.skip || 0).first(options.take || Math.pow(2, 31)).value();
    cb(null, {
      items: items,
      total: total
    });
    uiBlocker.unblock(this.blockerContainer, 'getCampaignBlocker');
  };
  var removeAllBlockers = function (blockerContext) {
    var blockerContainer = blockerContext.blockerContainer;
    if (this.blockerContainer && this.blockerContainer.length == 1) {
      blockerContainer = this.blockerContainer;
    }
    uiBlocker.unblock(blockerContainer, 'getCampaignBlocker');
    uiBlocker.unblock(blockerContainer, 'getAdgroupBlocker');
  };
  var getAdgroupDataServer = function (controlOptions, options, cb) {
    var campaignId = this.viewModel.selectedCampaign() ? this.viewModel.selectedCampaign().Id : null, campaign = this.viewModel.selectedCampaign() ? this.viewModel.selectedCampaign() : null, predicate = controlOptions.filterPredicate, scope = controlOptions.scope, controlMode = controlOptions.controlMode, filterText = this.viewModel.filterText() || options.filterText, adgroupPredicate = predicate ? predicate.adgroup : null, self = this;
    options = _.extend(options, {
      data: {
        campaignId: campaignId,
        campaign: campaign
      },
      customFilter: adgroupPredicate
    });
    if (!campaignId && (!filterText || filterText === '')) {
      cb(null, {
        items: [],
        total: 0
      });
      this.viewModel.adgroups([]);
    } else {
      instruSvc.startActivity(setting.ACTIVITYNAME.AdgroupSelectorLoadAdgroups);
      uiBlocker.block(this.blockerContainer, 'getAdgroupBlocker', true);
      var adgroups = new AdGroupCollection();
      adgroups.set('adgroupOptions', {
        allowCaching: false,
        skip: options.skip || 0,
        take: options.take || 20000,
        campaignId: campaignId,
        nameFilterText: filterText,
        predicate: adgroupPredicate,
        scope: scope,
        controlMode: controlMode
      });
      $.advertiser.clearErrorSummary();
      adgroups.fetch().done(_.bind(_filterAdgroupsServer, this, options, scope, cb)).fail(function (error) {
        if (_.isFunction(controlOptions.errorCb)) {
          controlOptions.errorCb(error);
        }
        cb(error);
        legacy$.advertiser.appendErrorSummary(i18n.getString('GenericErrorMessage'));
        uiBlocker.unblock(self.blockerContainer, 'getAdgroupBlocker');
        instruSvc.endActivity(setting.ACTIVITYNAME.AdgroupSelectorLoadAdgroups, false);
      });
    }
  };
  var getAdgroupDataClient = function (controlOptions, options, cb) {
    var campaignId = this.viewModel.selectedCampaign() ? this.viewModel.selectedCampaign().Id : null, campaign = this.viewModel.selectedCampaign() ? this.viewModel.selectedCampaign() : null, scope = controlOptions.scope, filterText = options.filterText || this.viewModel.filterText(), predicate = controlOptions.filterPredicate, adgroupPredicate = predicate ? predicate.adgroup : null;
    options = _.extend(options, {
      data: {
        campaignId: campaignId,
        campaign: campaign
      },
      customFilter: adgroupPredicate,
      filterText: filterText,
      skip: options.skip,
      take: options.take
    });
    if (!campaignId && !filterText) {
      cb(null, {
        items: [],
        total: 0
      });
    } else {
      uiBlocker.block(this.blockerContainer, 'getAdgroupBlocker', true);
      this.entityService.getAdgroups(_.extend(options, {
        success: _.bind(_filterAdgroups, this, options, scope, cb),
        fail: function (error) {
          cb(error);
          uiBlocker.unblock(this.blockerContainer, 'getAdgroupBlocker');
        },
        filterPredicate: adgroupPredicate
      }));
    }
  };
  var getAdgroupData = function (controlOptions, options, cb) {
    if (this.useInjectedAdgroupFetch) {
      return this.getAdgroupDataClient(controlOptions, options, cb);
    } else {
      return this.getAdgroupDataServer(controlOptions, options, cb);
    }
  };
  var _filterAdgroupsServer = function (options, scope, cb, data) {
    var result = {};
    result.data = data.value;
    result.total = data.hasOwnProperty('@odata.count') ? data['@odata.count'] : 0;
    _filterAdgroups.call(this, options, scope, cb, result);
    instruSvc.endActivity(setting.ACTIVITYNAME.AdgroupSelectorLoadAdgroups);
  };
  var getAdsCount = function (adgroupData, campaign, account, customer) {
    return new Promise(function (resolve) {
      if (campaign && campaign.CampaignSubType !== 12 && campaign.CampaignSubType !== 'ShoppingSmartAds') {
        resolve({});
      } else if (adgroupData && adgroupData.length === 0) {
        resolve({});
      } else {
        if (!campaign) {
          campaign = _.first(adgroupData).Campaign;
        }
        if (!Array.isArray(adgroupData)) {
          adgroupData = [adgroupData];
        }
        var adgroupIds = _.map(adgroupData, function (adgroup) {
          return adgroup.Id;
        });
        odata.post('Customers(' + customer.Id + ')/Accounts(' + account.Id + ')/Campaigns(' + campaign.Id + ')/Ads/Default.GetAdCount', {
          data: {
            adGroupIds: adgroupIds
          }
        }).then(function (obj) {
          var adsCount = _.result(obj, 'value', []);
          var adsCountMap = {};
          adsCount.forEach(function (item) {
            adsCountMap[item.AdGroupId] = _.object(item.AdsCountByAdType.Keys, item.AdsCountByAdType.Values);
          });
          resolve(adsCountMap);
        }).catch(function (e) {
          console.log(e);
          resolve({});
        });
      }
    });
  };
  var _filterAdgroups = function (options, scope, cb, data) {
    var scenario = scope && scope.scenario;
    if (!data || !data.data) {
      return;
    }
    var adgroupData = data.data, campaign = options.data.campaign;
    _.each(adgroupData, function (ag) {
      if (campaign && ag.Campaign.Id === campaign.Id) {
        ag.isFeedBasedCampaign = !!_.result(_.take(campaign.CampaignSettings), 'ProviderId');
      }
    });
    Promise.resolve(scenario === 'ads-create' ? getAdsCount(adgroupData, campaign, scope.account, scope.customer) : {}).bind(this).then(function (adsCountMap) {
      var query = _.chain(adgroupData).filter(function (adgroup) {
        return shouldKeepSmartShoppingCampaignAdGroup(adgroup, adsCountMap);
      }).map(function (adg) {
        return _.extend(adg, {
          parentId: adg.Campaign.Id,
          parentName: adg.Campaign.Name,
          name: adg.Name,
          statusHtml: getStatusHtml(adgroupStatusList, adg.Status, 'Adgroup'),
          adsCountMap: adsCountMap
        });
      });
      if (_.isFunction(options.customFilter)) {
        query = query.filter(options.customFilter);
      }
      var items = query.value();
      var isShoppingSmartAd = campaign && (campaign.CampaignSubType === 12 || campaign.CampaignSubType === 'ShoppingSmartAds');
      var total = !isShoppingSmartAd && data.total ? data.total : items.length;
      cb(null, {
        items: items,
        total: total
      });
      uiBlocker.unblock(this.blockerContainer, 'getAdgroupBlocker');
    });
  };
  var _getSearchPredicate = function (filterText) {
    return function (item) {
      if (!item) {
        return;
      }
      return item.Name.toLowerCase().indexOf(filterText.toLowerCase()) !== -1;
    };
  };
  var _getStatusClass = function (status, original) {
    var resultClass = original;
    switch (status) {
      case 'Active':
        resultClass = 'statusEnabled_icon';
        break;
      case 'Excluded':
        resultClass = 'statusExcluded_icon';
        break;
      case 'Deleted':
        resultClass = 'statusDeleted_icon';
        break;
      case 'Suspended':
        resultClass = 'statusSuspended_icon';
        break;
      case 'UserPaused':
      case 'BudgetPaused':
      case 'BudgetUserPaused':
      case 'Paused':
        resultClass = 'statusPaused_icon';
        break;
    }
    return resultClass;
  };
  var getStatusHtml = function (statusList, status, entityType) {
    var className = _getStatusClass(status, 'statusEnabled_icon');
    className = _getStatusClass(statusList[status], className);
    var prefix = '';
    if (entityType === 'Adgroup') {
      prefix = i18n.getString('EntityType_AdGroup_Singular') + ' ';
    } else if (entityType === 'Campaign') {
      prefix = i18n.getString('EntityType_Campaign_Singular') + ' ';
    }
    return '<span class="statusIcon ' + className + '" title="' + prefix + i18n.getString(statusIconLabelList[className]) + '"></span>';
  };
  var setControlScope = function (scope, viewModel) {
    switch (scope.currentScope) {
      default:
        viewModel.scope = viewModel.controlModes.account;
        break;
      case 'campaign':
        var campaign = extendProperties(scope.campaign);
        viewModel.selectedCampaign(campaign);
        viewModel.scope = viewModel.controlModes.campaign;
        break;
      case 'adgroup':
        var campaign = extendProperties(scope.campaign), adgroup = extendProperties(scope.adgroup);
        adgroup = _.extend(adgroup, {
          Campaign: campaign
        });
        viewModel.selectedCampaign(campaign);
        if (viewModel.hasOwnProperty('selectedAdgroup')) {
          viewModel.selectedAdgroup(adgroup);
        }
        viewModel.scope = viewModel.controlModes.adgroup;
        break;
    }
  };
  var extendProperties = function (entity) {
    return _.extend(entity, {
      Id: entity.Id || entity.id,
      Name: entity.Name || entity.name
    });
  };
  var extendAdgroup = (function (observable, adgroup) {
    uiBlocker.block(this.blockerContainer, 'getAdgroupBlocker', true);
    entityService.getAdgroup(adgroup.Campaign.Id, adgroup.Id).then(_.bind(function (adg) {
      observable(_.extend(adgroup, adg));
      uiBlocker.unblock(this.blockerContainer, 'getAdgroupBlocker');
    }, this), _.bind(function (error) {
      observable(adgroup);
      uiBlocker.unblock(this.blockerContainer, 'getAdgroupBlocker');
    }, this));
  }).asLoggingStart(setting.ACTIVITYNAME.AdgroupSelectorLoadExtendedAdgroup);
  return {
    getCampaignData: getCampaignData,
    getAdgroupData: getAdgroupData,
    getAdgroupDataServer: getAdgroupDataServer,
    getAdgroupDataClient: getAdgroupDataClient,
    removeAllBlockers: removeAllBlockers,
    getStatusHtml: getStatusHtml,
    setControlScope: setControlScope,
    extendProperties: extendProperties,
    extendAdgroup: extendAdgroup,
    getAdsCount: getAdsCount
  };
})();
export default Service;

